import React, { FunctionComponent } from "react";

import { useTireResults } from "../../Tires/Results/useTireResults";
import { useProductModalHash } from "../ProductModal";
import { TireDetails } from "./TireDetails";

export const TireModalContent: FunctionComponent = () => {
  const { data: results } = useTireResults();
  const { itemId } = useProductModalHash();

  const product = results?.allParts.find(
    ({ partDetails }) => partDetails.primaryPart.itemId === itemId
  );

  return <TireDetails part={product || null} />;
};
